import type { IKeyValuePair } from "./interface"

export const cityList: IKeyValuePair[] = [
    {
        label: 'Metro Manila',
        value: 'US',
    },
    {
        label: 'Paranaque',
        value: 'CA'
    },
    {
        label: 'Makati',
        value: 'FR'
    },
    {
        label: 'Cebu',
        value: 'DE'
    }
]

export const stateList: IKeyValuePair[] = [
    {
        label: 'Metro Manila',
        value: 'US',
    },
    {
        label: 'Paranaque',
        value: 'CA'
    },
    {
        label: 'Makati',
        value: 'FR'
    },
    {
        label: 'Cebu',
        value: 'DE'
    }
]

export const positionList: IKeyValuePair[] = [
    {
        label: 'Owner',
        value: 1
    },
    {
        label: 'Employees',
        value: 2
    },
]

export const categoryList: IKeyValuePair[] = [
    {
        label: 'Japanese',
        value: 1
    },
    {
        label: 'Filipino',
        value: 2
    },
    {
        label: 'Taiwanese',
        value: 3
    },
    {
        label: 'American',
        value: 4
    },
    {
        label: 'French',
        value: 5
    },
    {
        label: 'Chinese',
        value: 6
    },
    {
        label: 'Korean',
        value: 7
    },
    {
        label: 'Thai',
        value: 8
    },
    {
        label: 'Vietnam',
        value: 9
    },
]

export const dishTypeList: IKeyValuePair[] = [
    {
        label: 'Sushi',
        value: 1
    },
    {
        label: 'Ramen',
        value: 2
    },
]

export const paymentList: IKeyValuePair[] = [
    {
        label: 'Credit Card',
        value: 1
    },
    {
        label: 'Debit',
        value: 2
    },
]

export const diningTypeList: IKeyValuePair[] = [
    {
        label: 'Solo Dining',
        value: 'solo-dining'
    },
    {
        label: 'Couple Date',
        value: 'couple-date'
    },
    {
        label: 'Family Bonding',
        value: 'family-bonding'
    },
    {
        label: 'Buffet',
        value: 'buffet'
    },
    {
        label: 'Reception',
        value: 'reception'
    },
]

export const planList: IKeyValuePair[] = [
    {
        label: 'Basic Plan (P0/month)',
        value: 1
    },
    {
        label: 'Standard Plan (P4,000/month)',
        value: 2
    },
    {
        label: 'Premium Plan (P10,000/month)',
        value: 3
    },
]